import React, { ReactElement } from 'react'
import { v4 as uuid } from 'uuid'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { HorizontalItem, HorizontalList } from './Item'
import SociaLink from './SocialLink'
import { usePageContext } from './PageContext'

import { ReactComponent as SpotifyIcon } from '../svg/spotify.svg'
import { ReactComponent as YouTubeIcon } from '../svg/youtube.svg'
import { ReactComponent as TikTokIcon } from '../svg/tiktok.svg'
import { ReactComponent as InstagramIcon } from '../svg/instagram.svg'

const StyledFooter = styled.footer`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 16px 34px;
    margin-top: 18px;
    width: min(900px, 100%);
    color: ${(props) => props.theme.secondaryText};
    border-top: 1px solid ${(props) => props.theme.border};
    gap: 10px;
`

const FooterLink = styled(Link)`
    color: ${(props) => props.theme.secondaryText};
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;

    &:hover {
        color: ${(props) => props.theme.text};
    }
`

const FooterText = styled.p`
    font-weight: 400;
    margin: 0;
    color: ${(props) => props.theme.secondaryText};
    font-size: 0.88rem;

    a {
        color: ${(props) => props.theme.text};
        text-decoration: underline;
        text-decoration-color: ${(props) => props.theme.border};
        text-underline-offset: 3px;
    }
`

const LabelDescriptor = styled.p`
    margin: 0;
    color: ${(props) => props.theme.secondaryText};
    font-size: 0.8rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`

export default function Footer(): ReactElement {
    const pageData = usePageContext()

    const socialLinks = [
        { svg: <YouTubeIcon />, link: pageData?.youtube },
        { svg: <SpotifyIcon />, link: pageData?.spotify },
        { svg: <TikTokIcon />, link: pageData?.tiktok },
        { svg: <InstagramIcon />, link: pageData?.instagram },
    ].filter((link) => link.link) // Filter out empty links

    return (
        <>
            <StyledFooter>
                <HorizontalList>
                    <HorizontalItem>
                        <FooterLink to="/">Landing Page</FooterLink>
                    </HorizontalItem>
                    <HorizontalItem>
                        <FooterLink to="/impressum">Legal Notice</FooterLink>
                    </HorizontalItem>
                </HorizontalList>
                <HorizontalList>
                    {socialLinks.map((socialLink) => (
                        <HorizontalItem key={uuid()}>
                            <SociaLink
                                svg={socialLink.svg}
                                link={socialLink.link}
                            />
                        </HorizontalItem>
                    ))}
                </HorizontalList>
                <HorizontalList>
                    <FooterText>
                        © {new Date().getFullYear()} {pageData?.name}
                    </FooterText>
                </HorizontalList>
            </StyledFooter>
        </>
    )
}
